var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['button', ( _obj = {}, _obj[_vm.btnClass] = _vm.bgColor, _obj )],attrs:{"disabled":_vm.disabled},on:{"click":_vm.clickHandler}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }